module.exports = __webpack_public_path__ + "static/media/bar.897617e2.png";